// @flow

import React from "react";
import { connect } from "react-redux";

import ReportName from "src/components/Manage/Reports/Name";
import { getChart } from "src/reducers";

import type { AppState, Charts } from "src/types";

type Props = {
  chart: Charts,
};

const Report = ({ chart }: Props) => <ReportName id={chart.reportId} />;

const mapStateToProps = ({ app }: { app: AppState }, props) => ({
  chart: getChart(app, props.id),
});

export default connect(mapStateToProps)(Report);
